import { Body1, Box, Color, FontFamily } from '@gousto-internal/citrus-react'
import React from 'react'

export function PromoBannerText({ children }: { children: string }) {
  return (
    <Box maxWidth={'100%'}>
      <Body1 color={Color.White} size={[2, 3]} fontFamily={FontFamily.Bold}>
        {children}
      </Body1>
    </Box>
  )
}
